export { default } from './SkeletonBreakingDealsCarouselMobile';
